import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store/store';
import Login from './pages/Login/Login';
import PrivateRoute from './common/components/PrivateRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import NotFound from './pages/NotFound/NotFound';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CollegeList from './pages/CollegeList/CollegeList';
import Exams from './pages/Exams/Exams';
import Services from './pages/Services/DcpServices';
import Subscription from './pages/Subscription';
import TermCondition from './pages/TermCondition';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';
import FAQ from './pages/FAQ/FAQ';
import Notifications from './pages/Notification';
import theme from './theme';
import SignUp from './pages/SignUp/SignUp';
import ProfileSetUp from './pages/ProfileSetUp/ProfileSetUp';
import ContactSupport from './pages/ContactSupport';
import ParentAccount from './pages/ParentAccount/ParentAccount';
import Calendar from './pages/Calendar/Calendar';
import MyProfile from './pages/Settings/MyProfile';
import LandingPage from './pages/LandingPage/LandingPage';
import AuthRedirect from './common/components/AuthRedirect';
import { ToastContainer } from 'react-toastify';
import SetPassword from './pages/SetPassword/SetPassword';
import AdminLogin from './pages/AdminLogin/AdminLogin';
import AdminPrivateRoute from './common/components/AdminPrivateRoute';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import CommonHeader from './common/components/CommonHeader';
import StudentPerformance from './pages/StudentPerformance/StudentPerformance';
import DcpTutoring from './pages/Dcp Tutoring/DcpTutoring';
import BuildProject from './pages/Build Project/BuildProject';
import DcpCounsellor from './pages/Dcp Counsellor/DcpCounsellor';
import SatActCoach from './pages/SAT ACT Coach/SatActCoach';
import ProjectDetails from './pages/Project Details/ProjectDetais';
import Newsletter from './pages/Newsletter/NewsLetter';
import ManageFAQ from './pages/Manage FAQ/ManageFAQ';
import ManagePage from './pages/Manage Static Page/ManagePage';
import ManageBlogs from './pages/Manage Blogs/ManageBlogs';
import IndividualBlog from './pages/LandingPage/IndividualBlog';
import ManageUsers from './pages/Manage Users/ManageUser';
import ManageProject from './pages/Manage Project/ManageProject';
import Chat from './pages/Chat Support/Chat';
import ManageMentor from './pages/Manage Mentor/ManageMentor';
import ProjectIntakeForm from './pages/Project Inake Form/ProjectInakeForm';
import BookSession from './pages/BookSession/BookSession';
import Support from './pages/Dcp Support/Support';
import TicketDetail from './pages/Dcp Support/TicketDetail';
import AiChat from './pages/AiChat/AiChat';
import IntakeForm from './pages/LandingPage/IntakeForm';
import MentorLogin from './pages/MentorLogin/MentorLogin';
import MentorPrivateRoute from './common/components/MentorPrivateRoute';
import MentorDashboard from './pages/MentorDashboard/MentorDashboard';
import MentorCalendar from './pages/MentorCalendar/Calendar';
import StudentList from './pages/StudentList/StudentList';
import ManageProfile from './pages/Manage Profile/ManageProfile';
import StudentDetail from './pages/StudentDetail/StudentDetail';
import InviteCounsellor from './pages/InviteCounsellor/InviteCounsellor';
import Blogs from './pages/LandingPage/Blogs';
import SessionReview from './pages/SessionReview';
import ManageMeeting from './pages/Manage Meeting/ManageMeeting';
import ManageAlert from './pages/Manage Alert/ManageAlert';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route
              path="/"
              element={
                <AuthRedirect>
                  <LandingPage />
                </AuthRedirect>
              }
            />
            <Route
              path="/register"
              element={
                <AuthRedirect>
                  <SignUp />
                </AuthRedirect>
              }
            />
            <Route
              path="/login"
              element={
                <AuthRedirect>
                  <Login />
                </AuthRedirect>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <AuthRedirect>
                  <ForgotPassword />
                </AuthRedirect>
              }
            />
            <Route
              path="/reset-password"
              element={
                <AuthRedirect>
                  <ResetPassword />
                </AuthRedirect>
              }
            />
            <Route
              path='accept-invitation'
              element={
                <AuthRedirect>
                  <SetPassword />
                </AuthRedirect>
              }
            />
            <Route
              path="/profile-setup"
              element={
                <AuthRedirect>
                  <ProfileSetUp />
                </AuthRedirect>
              }
            />

            <Route
              path="/intake-form"
              element={
                <AuthRedirect>
                  <IntakeForm />
                </AuthRedirect>
              }
            />

            <Route
              path="/my-dcp-terms-conditions"
              element={
                <CommonHeader>
                  <TermCondition />
                </CommonHeader>
              }
            />
            <Route
              path="/blogs"
              element={
                <CommonHeader>
                  <Blogs fromBlog />
                </CommonHeader>
              }
            />
            <Route
              path="/my-dcp-privacy-policy"
              element={
                <CommonHeader>
                  <PrivacyPolicy />
                </CommonHeader>
              }
            />
            <Route
              path="/my-dcp-about-us"
              element={
                <CommonHeader>
                  <AboutUs />
                </CommonHeader>
              }
            />
            <Route
              path="/my-dcp-faq"
              element={
                <CommonHeader>
                  <FAQ />
                </CommonHeader>
              }
            />
            <Route
              path="/dcp-faq"
              element={
                <PrivateRoute>
                  <FAQ />
                </PrivateRoute>
              }
            />
            <Route
              path="/dcp-support"
              element={
                <PrivateRoute>
                  <Support />
                </PrivateRoute>
              }
            />
            <Route
              path="/ticket/:ticketId"
              element={
                <PrivateRoute>
                  <TicketDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/contact-us"
              element={
                <CommonHeader>
                  <ContactSupport />
                </CommonHeader>
              }
            />
            <Route
              path="/blog/:id"
              element={
                <IndividualBlog />
              }
            />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/session-review"
              element={
                <PrivateRoute>
                  <SessionReview />
                </PrivateRoute>
              }
            />

            <Route
              path="/colleges"
              element={
                <PrivateRoute>
                  <CollegeList />
                </PrivateRoute>
              }
            />
            <Route
              path="/course-exams"
              element={
                <PrivateRoute>
                  <Exams />
                </PrivateRoute>
              }
            />
            <Route
              path="/services"
              element={
                <PrivateRoute>
                  <Services />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-dcp-calendar"
              element={
                <PrivateRoute>
                  <Calendar />
                </PrivateRoute>
              }
            />
            <Route
              path="/student-performace-tracker"
              element={
                <PrivateRoute>
                  <StudentPerformance />
                </PrivateRoute>
              }
            />
            <Route
              path="/dcp-tutoring"
              element={
                <PrivateRoute>
                  <DcpTutoring />
                </PrivateRoute>
              }
            />
            <Route
              path="/dcp-skill-coaching"
              element={
                <PrivateRoute>
                  <DcpTutoring />
                </PrivateRoute>
              }
            />
            <Route
              path="/book-session"
              element={
                <PrivateRoute>
                  <BookSession />
                </PrivateRoute>
              }
            />
            <Route
              path="/invite-counsellor"
              element={
                <PrivateRoute>
                  <InviteCounsellor />
                </PrivateRoute>
              }
            />
            <Route
              path="/ai-chat"
              element={
                <PrivateRoute>
                  <AiChat />
                </PrivateRoute>
              }
            />
            <Route
              path="/build-project"
              element={
                <PrivateRoute>
                  <BuildProject />
                </PrivateRoute>
              }
            />
            <Route
              path="/project-workspace"
              element={
                <MentorPrivateRoute>
                  <ProjectDetails fromMentor />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/project-details"
              element={
                <PrivateRoute>
                  <ProjectDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-dcp-counsellor"
              element={
                <PrivateRoute>
                  <DcpCounsellor />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-dcp-sat-act-coach"
              element={
                <PrivateRoute>
                  <SatActCoach />
                </PrivateRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              }
            />
            <Route
              path='/my-profile'
              element={
                <PrivateRoute>
                  <MyProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <PrivateRoute>
                  <Subscription />
                </PrivateRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <PrivateRoute>
                  <Notifications />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-contact-support"
              element={
                <PrivateRoute>
                  <ContactSupport />
                </PrivateRoute>
              }
            />
            <Route
              path="/my-parent-account"
              element={
                <PrivateRoute>
                  <ParentAccount />
                </PrivateRoute>
              }
            />
            <Route
              path="/project-intake-form"
              element={
                <PrivateRoute>
                  <ProjectIntakeForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AuthRedirect>
                  <AdminLogin />
                </AuthRedirect>
              }
            />
            <Route
              path="/mentor"
              element={
                <AuthRedirect>
                  <MentorLogin />
                </AuthRedirect>
              }
            />
            <Route
              path="/mentor-dashboard"
              element={
                <MentorPrivateRoute>
                  <MentorDashboard />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/schedule-calendar"
              element={
                <MentorPrivateRoute>
                  <MentorCalendar />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/communication-hub"
              element={
                <MentorPrivateRoute>
                  <Chat fromMentor />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/manage-profile"
              element={
                <MentorPrivateRoute>
                  <ManageProfile />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/my-students"
              element={
                <MentorPrivateRoute>
                  <StudentList />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/student-detail/:studentId"
              element={
                <MentorPrivateRoute>
                  <StudentDetail />
                </MentorPrivateRoute>
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <AdminPrivateRoute>
                  <AdminDashboard />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/news-letter"
              element={
                <AdminPrivateRoute>
                  <Newsletter />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-faq"
              element={
                <AdminPrivateRoute>
                  <ManageFAQ />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-static-page"
              element={
                <AdminPrivateRoute>
                  <ManagePage />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-blogs"
              element={
                <AdminPrivateRoute>
                  <ManageBlogs />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-meetings"
              element={
                <AdminPrivateRoute>
                  <ManageMeeting />
                </AdminPrivateRoute>
              }
            />
             <Route
              path="/manage-alert"
              element={
                <AdminPrivateRoute>
                  <ManageAlert />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-users"
              element={
                <AdminPrivateRoute>
                  <ManageUsers />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-dcp-projects"
              element={
                <AdminPrivateRoute>
                  <ManageProject />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/manage-mentors"
              element={
                <AdminPrivateRoute>
                  <ManageMentor />
                </AdminPrivateRoute>
              }
            />

            <Route
              path="/support-help-desk"
              element={
                <AdminPrivateRoute>
                  <Support />
                </AdminPrivateRoute>
              }
            />
            <Route
              path="/support-ticket/:ticketId"
              element={
                <AdminPrivateRoute>
                  <TicketDetail />
                </AdminPrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;